"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const app_types_1 = require("pages/app.types");
const toolkit_1 = require("@reduxjs/toolkit");
const production_statistic_types_1 = require("./production-statistic.types");
const moment_1 = __importDefault(require("moment"));
const initialState = {
    isError: false,
    isLoading: true,
    isSuccess: false,
    errorCode: 0,
    errorMessage: '',
    dataGrid: [],
    mutationMode: false,
    isLoadingExport: false,
    documentExport: {
        content: '',
        filename: '',
        filetype: '',
    },
    dataItem: {
        id: '',
        penalty: '',
        pos_name: '',
        pit_name: '',
        ticket_no: '',
        lead_time: '',
        area_name: '',
        seam_name: '',
        brand_name: '',
        queue_time: '',
        nett_volume: 0,
        modified_by: '',
        dumptruck_no: '',
        excavator_no: '',
        date: new Date(),
        capacity_volume: 0,
        gate_in: new Date(),
        gate_out: new Date(),
        contractor_dt_code: '',
        contractor_ex_code: '',
        modified_date: new Date(),
        main_entrance_in: new Date(),
    },
    start_date: (0, moment_1.default)().format('YYYY-MM-DD'),
    end_date: (0, moment_1.default)().format('YYYY-MM-DD'),
    dataStates: {
        sortable: false,
        filterable: true,
        reorderable: false,
        scrollable: 'scrollable',
        skip: 0,
        take: 10,
        total: 0,
        sort: [{ field: 'gate_in', dir: 'desc' }]
    }
};
const productionStatisticReducer = (0, toolkit_1.createReducer)(initialState, {
    [app_types_1.appTypes.RESET_LOADING]: () => {
        return Object.assign({}, initialState);
    },
    [production_statistic_types_1.productionStatisticTypes.SET_IS_LOADING]: (state, action) => {
        const { isLoading } = action.payload;
        return Object.assign(Object.assign({}, state), { isLoading });
    },
    [production_statistic_types_1.productionStatisticTypes.SET_DATA_GRID]: (state, action) => {
        const { dataGrid, count } = action.payload;
        return Object.assign(Object.assign({}, state), { dataGrid, isLoading: false, dataStates: Object.assign(Object.assign({}, state.dataStates), { total: count }) });
    },
    [production_statistic_types_1.productionStatisticTypes.ON_PAGE_CHANGE]: (state, action) => {
        const { dataStates } = action.payload;
        return Object.assign(Object.assign({}, state), { dataStates, isLoading: true });
    },
    [production_statistic_types_1.productionStatisticTypes.ON_FILTER_PAGE_CHANGE]: (state, action) => {
        const { dataStates } = action.payload;
        return Object.assign(Object.assign({}, state), { dataStates });
    },
    [production_statistic_types_1.productionStatisticTypes.ON_MUTATION_CLICK]: (state, action) => {
        const { dataItem, mutationMode, isSuccess, isLoadingExport } = action.payload;
        return Object.assign(Object.assign({}, state), { mutationMode: mutationMode, dataItem: dataItem ? dataItem : initialState.dataItem, isSuccess: isSuccess ? isSuccess : initialState.isSuccess, isLoadingExport: isLoadingExport ? isLoadingExport : initialState.isLoadingExport });
    },
    [production_statistic_types_1.productionStatisticTypes.ON_DATE_CHANGE]: (state, action) => {
        const { start_date, end_date } = action.payload;
        return Object.assign(Object.assign({}, state), { start_date, end_date: end_date ? end_date : (0, moment_1.default)().format('YYYY-MM-DD'), isLoading: true });
    },
    [production_statistic_types_1.productionStatisticTypes.ON_SAVE_DATAITEM]: (state, action) => {
        const { dataItem, isSuccess } = action.payload;
        return Object.assign(Object.assign({}, state), { isSuccess, mutationMode: false, dataItem: initialState.dataItem, dataGrid: state.dataGrid.map(item => {
                if (item.id === (dataItem === null || dataItem === void 0 ? void 0 : dataItem.id))
                    return dataItem;
                return item;
            }) });
    },
    [production_statistic_types_1.productionStatisticTypes.SET_ERROR]: (state, action) => {
        return Object.assign(Object.assign(Object.assign({}, state), action.payload), { isLoading: false, isSuccess: false, isLoadingExport: false });
    },
    [production_statistic_types_1.productionStatisticTypes.ON_FILTER_CHANGE]: (state, action) => {
        return Object.assign(Object.assign({}, state), { 
            // isLoading: true,
            dataStates: Object.assign(Object.assign({}, state.dataStates), { filter: action.payload }) });
    },
    [production_statistic_types_1.productionStatisticTypes.ON_SORT_CHANGE]: (state, action) => {
        return Object.assign(Object.assign({}, state), { isLoading: true, dataStates: Object.assign(Object.assign({}, state.dataStates), { isLoading: true, sort: action.payload }) });
    },
    [production_statistic_types_1.productionStatisticTypes.SET_EXPORT_DOCUMENTS_URL]: (state, action) => {
        const { name, type, content } = action.payload;
        return Object.assign(Object.assign({}, state), { isLoading: false, isLoadingExport: false, documentExport: {
                content: content,
                filename: name,
                filetype: type,
            } });
    },
    [production_statistic_types_1.productionStatisticTypes.CLEAR_EXPORT_DOCUMENTS_URL]: (state) => {
        return Object.assign(Object.assign({}, state), { isLoading: false, documentExport: {
                content: '',
                filename: '',
                filetype: '',
            } });
    }
});
exports.default = productionStatisticReducer;
